<div class="wrap">
    <button class="close-button" (click)="closeModal()"><span class="icon-close"></span></button>
    <header>
        <h3 class="heading">{{ 'pages.userRecords.confirmAccountDialog.header' | translate }}</h3>
    </header>
    <div class="content" *ngIf="profile">
        <div class="col-wrap">
            <div class="col userBox">
                <div>
                    <div *ngIf="profile.picture; else defaultImage">
                        <img [src]='profile.picture'>
                    </div>
                
                    <ng-template #defaultImage> 
                        <img src="https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png" alt="demo-avatar">
                    </ng-template>
                </div>
                <div class="userInformation">
                    <div class="nameText">
                        {{ profile.firstName }} {{ profile.lastName }}
                    </div>
                    <div class="emailText">
                        {{ profile.email }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footer>
        <button class="bciti-button bciti-button-white" (click)="closeModal()">{{ 'pages.userRecords.confirmAccountDialog.cancelButton' | translate }}</button>
        <button class="bciti-button bciti-button--blue button-margin" (click)="sendConfirmAccountEmail()">{{ 'pages.userRecords.confirmAccountDialog.sendButton' | translate }}</button>
    </footer>
</div>